import { FC } from "react";
import {
  ChartWrapper,
  DataWrapper,
  StyledResponsiveContainer,
  StyledText,
  TitleWrapper,
} from "./styled";
import {
  XAxis,
  YAxis,
  Area,
  AreaChart as AreaChartRechart,
  Tooltip,
  Dot,
} from "recharts";
import { Typography } from "antd";

interface IProps {
  percent: string;
  symbol: string;
  title: string;
  value: string;
  color: string;
  data: { name: string; time: number }[] | undefined;
  ticks: string[] | undefined;
}

export const AreaChart: FC<IProps> = ({
  percent,
  symbol,
  title,
  value,
  color,
  data,
  ticks,
}) => {
  return (
    <ChartWrapper>
      <TitleWrapper>
        <Typography.Title style={{ margin: 0 }} level={5}>
          {title}
        </Typography.Title>

        <DataWrapper>
          <Typography.Title style={{ margin: 0, fontSize: "40px" }}>
            {value}
          </Typography.Title>

          <StyledText style={{ color: color }}>
            {symbol}
            {percent}%
          </StyledText>
        </DataWrapper>
      </TitleWrapper>

      <StyledResponsiveContainer width={"100%"} height={120}>
        <AreaChartRechart data={data}>
          <defs>
            <linearGradient id="color" x1="0" y1="0" x2="0" y2="1">
              <stop offset="3%" stopColor="#007BFB" stopOpacity={0.8} />
              <stop offset="97%" stopColor="#007BFB" stopOpacity={0} />
            </linearGradient>
          </defs>
          #2d6081
          <XAxis
            ticks={ticks}
            axisLine={false}
            tickLine={false}
            dataKey="name"
          />
          <YAxis
            tickFormatter={(number) => number + " ч"}
            axisLine={false}
            tickLine={false}
            ticks={[12, 24]}
          />
          <Dot r={5} />
          <Tooltip shared={false} />
          <Area
            activeDot={{ r: 5 }}
            strokeWidth={2}
            type="bumpX"
            dataKey="time"
            stroke="#007BFB"
            fill="url(#color)"
          />
        </AreaChartRechart>
      </StyledResponsiveContainer>
    </ChartWrapper>
  );
};
